import type { TUseGetSocialApplyByStatusResponse } from "@api";
import { SocialApplyStatus } from "@bbj-types/socialApply/enum";
import { IntegratedCandidates } from "./integratedCandidates";
import { Prescriptions } from "./prescriptions";
import { RefusedCandidates } from "./refusedCandidates";

interface ISocialOffersDetailsTableProps<T extends SocialApplyStatus> {
  tab: T;
  data: TUseGetSocialApplyByStatusResponse<T>["data"];
  refetchApplies: () => void;
}

export const SocialOffersDetailsTable = <T extends SocialApplyStatus>({
  tab,
  data,
  refetchApplies,
}: ISocialOffersDetailsTableProps<T>) => {
  switch (tab) {
    case SocialApplyStatus.PRESCRIPTION_FILLED:
      return (
        <Prescriptions
          data={data as TUseGetSocialApplyByStatusResponse<SocialApplyStatus.PRESCRIPTION_FILLED>["data"]}
        />
      );
    case SocialApplyStatus.INTEGRATED_CANDIDATE:
      return (
        <IntegratedCandidates
          data={data as TUseGetSocialApplyByStatusResponse<SocialApplyStatus.INTEGRATED_CANDIDATE>["data"]}
          refetchApplies={refetchApplies}
        />
      );
    case SocialApplyStatus.REFUSED_STRUCTURE:
      return (
        <RefusedCandidates
          data={data as TUseGetSocialApplyByStatusResponse<SocialApplyStatus.REFUSED_STRUCTURE>["data"]}
          refetchApplies={refetchApplies}
        />
      );
    default:
  }
};
